<template>
  <br />
  <router-view />
  <login-page v-if="shouldShowLoginPage" />
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

:root {
  --text: #0d0f0b;
  --background: #f7f8f5;
  --primary: #82b458;
  --secondary: #abc4bd;
  --accent: #6dd4b0;
}

#app {
  background-color: var(--background);
  color: var(--text);
  font-family: "Poppins", sans-serif;
  overflow-x: hidden;
  min-height: 100vh;
  margin: 0;
  width: 100vw;
}

body {
  margin: 0;
}

button {
  border: none;
  padding: 15px;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 50px;
  background-color: var(--primary);
}

.sec {
  background-color: var(--secondary);
}
</style>

<script setup lang="ts">
import axios from "axios";
import { getCurrentInstance, ref } from "vue";
import LoginPage from "@/components/LoginPage.vue";

const instance = getCurrentInstance();
const API_URL = instance?.appContext.config.globalProperties.API_URL;

const shouldShowLoginPage = ref(true);

async function validateAuth(): Promise<boolean> {
  try {
    const res = await axios.get(`${API_URL}/auth/validate`, {
      withCredentials: true,
    });

    return !res.data.failed;
  } catch (error: any) {
    console.log("Couldn't validate");
    return false;
  }
}

async function loginPageLoader() {
  shouldShowLoginPage.value = !(await validateAuth());
  console.log(shouldShowLoginPage);
}

loginPageLoader();
</script>
